export default "__VITE_ASSET__CYenXcPA__"